import React from 'react'
// BASE Components
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
// Material UI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';

import SubComponentCard from './SubComponent';

export default function MCInstructions({ins, course, dir, tl, componentCommentsCount, qIndex}) {

  return (
    <>
      {ins.filter(data => data.course === course.id || data.course === 'Default').map((data, index) => (
        <Paper key={`ins-${data.title}-${index}`} elevation={0} variant="outlined" square className="p-16 m-16">
          <Grid container spacing={1}>
            {/* <Grid item xs={12}>
              <Typography
                className="text-14 font-bold p-0 m-0"
              >
                {data.title}:
              </Typography>
            </Grid> */}
            <Grid item xs={12}>
              {data.course === 'Default' ? (
                <Typography 
                  className="m-0 wysiwyg"
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: data.content }}
                />
              ) : (
                <Typography 
                  className={`${tl} m-0 wysiwyg`}
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: data.content }}
                  dir={dir}
                />
              )}
              
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  )
}
